import { CreateDevicesState } from './states/create-devices.state';

export const createDevicesState = [CreateDevicesState];
